import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import s from './GroupCard.scss';
var GroupCard = /** @class */ (function (_super) {
    __extends(GroupCard, _super);
    function GroupCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupCard.prototype.render = function () {
        var _a = this.props, username = _a.username, imageUrl = _a.imageUrl, className = _a.className, biData = _a.biData;
        return (React.createElement(BiLink, { href: Url.userLink(username), className: classnames(s['root'], className), biData: biData },
            React.createElement("div", { className: s['img-wrap'] }, imageUrl && React.createElement("img", { src: imageUrl, alt: "" })),
            React.createElement("div", { className: s['name'] }, username)));
    };
    return GroupCard;
}(React.Component));
export { GroupCard };
export default GroupCard;
//# sourceMappingURL=GroupCard.js.map